import type { TfClient } from '../client-internal';
import type { Database } from '../types.gen';

export type AeoPage = Database['public']['Tables']['tf_aeo_pages']['Row'];
export type AeoPageInsert = Database['public']['Tables']['tf_aeo_pages']['Insert'];

export async function listAeoPages(c: TfClient, toolId: string): Promise<AeoPage[]> {
  const { data, error } = await c
    .from('tf_aeo_pages')
    .select('*')
    .eq('tool_id', toolId)
    .order('updated_at', { ascending: false });
  if (error) throw error;
  return data ?? [];
}

export async function upsertAeoPage(c: TfClient, input: AeoPageInsert): Promise<AeoPage> {
  const { data, error } = await c
    .from('tf_aeo_pages')
    .upsert(input, { onConflict: 'tool_id,kind,slug' })
    .select('*')
    .single();
  if (error) throw error;
  return data;
}
